/* 
  Varna (Swedish for warn/alert)
  Error/Info logging for SPA 
*/

import { set } from 'lodash'
import Rollbar from 'rollbar'

import { FeatureFlagAccess } from 'state/FeatureFlagState'

import { phiCheck, print } from 'utils/helpers'

import { BuildNumber } from 'v1/Constants'

let rollbar: Rollbar
const environment = (() => {
  switch (window.location.origin) {
    case 'https://apps.closedloop.ai':
      return 'production'
    case 'https://gcp.closedloop.ai':
      return 'production'
    case 'https://internal.closedloop.ai':
      return 'internal'
    case 'https://dev.closedloop.ai':
      return 'development'
    default:
      return 'local'
  }
})()

const ignoredMessages = [
  'axios/lib/core/createError in createError',
  'ResizeObserver loop completed with undelivered notifications.',
  "Cannot read property 'focus' of null",
  'ResizeObserver loop limit exceeded',
  'Request failed with status code 404',
  'Request failed with status code 403',
  'Request failed with status code 401',
  'Request failed with status code 400'
]

const varna = {
  init: () => {
    // Rollbar
    rollbar = new Rollbar({
      accessToken: '779d8c0e618346ec8fbf17817df8e3b3',
      captureUncaught: true,
      captureUnhandledRejections: true,
      environment,
      ignoredMessages,
      codeVersion: 'ui@' + (BuildNumber || 1),
      scrubTelemetryInputs: true,
      autoInstrument: {
        networkRequestBody: false,
        networkResponseBody: false,
        log: false
      },
      enabled: environment !== 'local',
      filterTelemetry: (e) => {
        const isNetworkCall =
          e.type === 'network' && (e.body.subtype === 'xhr' || e.body.subtype === 'fetch')
        const url = e.body.url as string

        if (isNetworkCall && url.includes('launchdarkly.com')) {
          return true
        }

        return false
      },
      transform: (data: any) => {
        set(data, 'client.javascript.plugins', [])
        return phiCheck.obscureData(data)
      },
      payload: {
        client: {
          javascript: {
            source_map_enabled: true,
            codeVersion: 'ui@' + (BuildNumber || 1),
            guess_uncaught_frames: true
          }
        }
      }
    })
  },
  setUser: ({ email }: { email: string }) => {
    // Rollbar
    rollbar?.configure({
      payload: {
        person: { id: email, email }
      }
    })
  },
  info: (message: string, data: Error | object = {}) => {
    // Rollbar
    if (FeatureFlagAccess().sendErrorsToRollbar) {
      rollbar?.info(message, data)
    }
  },
  error: (message: string, data: Error | object = {}) => {
    // Rollbar
    if (FeatureFlagAccess().sendErrorsToRollbar) {
      rollbar?.error(message, data)
    }
  },
  warn: (message: string, data: Error | object = {}) => {
    // Rollbar
    if (FeatureFlagAccess().sendErrorsToRollbar) {
      rollbar?.warn(message, data)
    }
  }
}

// Print Build Number to console
if (environment !== 'local') {
  setTimeout(() => {
    print(
      `%cBuild Number: ${BuildNumber}`,
      'border: 1px solid #888; font-weight: bold; padding: 4px 8px;'
    )
  }, 1000)
}

export default varna
